var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{staticClass:"permission_dialog",attrs:{"width":"850","persistent":"","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticStyle:{"height":"70px","border-bottom":"1px solid #c0c0c05c"}},[_c('v-col',[_c('span',{staticStyle:{"font-size":"20px","color":"#424242"}},[_vm._v(_vm._s(_vm.$t("permissions")))])]),_c('v-spacer'),_c('v-btn',{staticStyle:{"border-radius":"8px !important","border":"1px solid rgba(66, 66, 66, 0.05)","margin-bottom":"16px"},attrs:{"icon":"","color":"#424242"},on:{"click":function($event){_vm.$emit('close'),
              _vm.$store.commit(
                _vm.editLevel ? 'openLevelEditDialog' : 'openLevelAddDialog'
              )}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_c('v-card-text',{staticClass:"pt-4"},[_c('v-form',{ref:"form",staticStyle:{"overflow-y":"scroll","overflow-x":"hidden","height":"700px"},attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-row',[_c('v-col',{staticStyle:{"padding-left":"53px"},attrs:{"cols":"12"}},[_c('span',[_vm._v(_vm._s(_vm.$t("usage")))])]),_c('v-col',{staticStyle:{"padding-left":"67px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-3",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:([
                  _vm.selected_new.mobileOrWebUsage_Permission == 2
                    ? { 'background-color': '#A6CC39', color: '#ffffff' }
                    : {
                        'background-color': '#ffffff',
                        color: '#A6CC39',
                        border: '1px solid #A6CC39',
                      },
                ]),on:{"click":function($event){(_vm.selected_new.mobileOrWebUsage_Permission = 2),
                    (_vm.editing = true)}}},[_vm._v(_vm._s(_vm.$t("mobileonly")))]),_c('v-btn',{staticClass:"text-capitalize ml-3",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:([
                  _vm.selected_new.mobileOrWebUsage_Permission == 1
                    ? { 'background-color': '#A6CC39', color: '#ffffff' }
                    : {
                        'background-color': '#ffffff',
                        color: '#A6CC39',
                        border: '1px solid #A6CC39',
                      },
                ]),on:{"click":function($event){(_vm.selected_new.mobileOrWebUsage_Permission = 1),
                    (_vm.editing = false)}}},[_vm._v(_vm._s(_vm.$t("web&mobile")))])],1)],1),_c('v-divider',{staticClass:"mt-5 mb-6 mr-3",staticStyle:{"border":"1px solid #a6cc39"}}),_c('v-row',{staticClass:"pl-5 accessright"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("accessrights"))+" ")])]),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('library')},model:{value:(_vm.selected_new.library_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "library_Checked", $$v)},expression:"selected_new.library_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == true &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.library_Checked == false
                        ? [
                            !_vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.library_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.library_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == true &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.library_Checked == false
                        ? [
                            !_vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.library_Checked == true &&
                            _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.library_Checked == false &&
                                _vm.selected_new.library_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.library_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.library_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('lessonlearn')},model:{value:(_vm.selected_new.lessonlearn_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "lessonlearn_Checked", $$v)},expression:"selected_new.lessonlearn_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == true &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.lessonlearn_Checked == false
                        ? [
                            !_vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.lessonlearn_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.lessonLearn_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == true &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.lessonlearn_Checked == false
                        ? [
                            !_vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.lessonlearn_Checked == true &&
                            _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.lessonlearn_Checked == false &&
                                _vm.selected_new.lessonLearn_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.lessonlearn_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.lessonLearn_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('course')},model:{value:(_vm.selected_new.course_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "course_Checked", $$v)},expression:"selected_new.course_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == true &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.course_Checked == false
                        ? [
                            !_vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.course_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.course_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == true &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.course_Checked == false
                        ? [
                            !_vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.course_Checked == true &&
                            _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.course_Checked == false &&
                                _vm.selected_new.course_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.course_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.course_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('quiz')},model:{value:(_vm.selected_new.quiz_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "quiz_Checked", $$v)},expression:"selected_new.quiz_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == true &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.quiz_Checked == false
                        ? [
                            !_vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.quiz_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.quiz_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == true &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.quiz_Checked == false
                        ? [
                            !_vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.quiz_Checked == true &&
                            _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.quiz_Checked == false &&
                                _vm.selected_new.quiz_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.quiz_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.quiz_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('community')},model:{value:(_vm.selected_new.community_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "community_Checked", $$v)},expression:"selected_new.community_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == true &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.community_Checked == false
                        ? [
                            !_vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.community_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.community_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == true &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.community_Checked == false
                        ? [
                            !_vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.community_Checked == true &&
                            _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.community_Checked == false &&
                                _vm.selected_new.community_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.community_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.community_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('event')},model:{value:(_vm.selected_new.event_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "event_Checked", $$v)},expression:"selected_new.event_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == true &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.event_Checked == false
                        ? [
                            !_vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.event_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.event_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == true &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.event_Checked == false
                        ? [
                            !_vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.event_Checked == true &&
                            _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.event_Checked == false &&
                                _vm.selected_new.event_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.event_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.event_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('banner')},model:{value:(_vm.selected_new.banner_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "banner_Checked", $$v)},expression:"selected_new.banner_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == true &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.banner_Checked == false
                        ? [
                            !_vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.banner_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.banner_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == true &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.banner_Checked == false
                        ? [
                            !_vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.banner_Checked == true &&
                            _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.banner_Checked == false &&
                                _vm.selected_new.banner_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.banner_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.banner_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('feedbackbox')},model:{value:(_vm.selected_new.feedbackbox_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "feedbackbox_Checked", $$v)},expression:"selected_new.feedbackbox_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == true &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.feedbackbox_Checked == false
                        ? [
                            !_vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.feedbackbox_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.feedbackbox_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == true &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.feedbackbox_Checked == false
                        ? [
                            !_vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.feedbackbox_Checked == true &&
                            _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.feedbackbox_Checked == false &&
                                _vm.selected_new.feedbackbox_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.feedbackbox_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.feedbackbox_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('usermanagement')},model:{value:(_vm.selected_new.usermanage_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "usermanage_Checked", $$v)},expression:"selected_new.usermanage_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == true &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.usermanage_Checked == false
                        ? [
                            !_vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.usermanage_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.usermanage_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == true &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.usermanage_Checked == false
                        ? [
                            !_vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.usermanage_Checked == true &&
                            _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.usermanage_Checked == false &&
                                _vm.selected_new.usermanage_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.usermanage_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.usermanage_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('companyprofile')},model:{value:(_vm.selected_new.companyProfile_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "companyProfile_Checked", $$v)},expression:"selected_new.companyProfile_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  true &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.companyProfile_Checked == false
                        ? [
                            !_vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.companyProfile_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.companyProfile_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  true &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.companyProfile_Checked == false
                        ? [
                            !_vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.companyProfile_Checked == true &&
                            _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.companyProfile_Checked ==
                                  false &&
                                _vm.selected_new.companyProfile_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.companyProfile_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.companyProfile_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('sendnotification')},model:{value:(_vm.selected_new.sendnoti_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "sendnoti_Checked", $$v)},expression:"selected_new.sendnoti_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == true &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.sendnoti_Checked == false
                        ? [
                            !_vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.sendnoti_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.sendnoti_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == true &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.sendnoti_Checked == false
                        ? [
                            !_vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.sendnoti_Checked == true &&
                            _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.sendnoti_Checked == false &&
                                _vm.selected_new.sendnoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.sendnoti_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.sendnoti_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('setting') + ' - ' + _vm.$t('notification')},model:{value:(_vm.selected_new.settingNoti_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "settingNoti_Checked", $$v)},expression:"selected_new.settingNoti_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == true &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.settingNoti_Checked == false
                        ? [
                            !_vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.settingNoti_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.settingNoti_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false
                        ? [
                            !_vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == true &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : _vm.selected_new.settingNoti_Checked == false
                        ? [
                            !_vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]
                        : [
                            _vm.selected_new.settingNoti_Checked == true &&
                            _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 1
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#0000001f !important',
                                  color: '#424242 !important',
                                }
                              : _vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff',
                                  color: '#A6CC39',
                                  border: '1px solid #A6CC39',
                                }
                              : !_vm.selected_new.settingNoti_Checked == false &&
                                _vm.selected_new.settingNoti_Permission == 0
                              ? {
                                  'background-color': '#ffffff !important',
                                  color: '#424242 !important',
                                  border: '1px solid #CCCCCC !important',
                                }
                              : {
                                  'background-color': '#A6CC39',
                                  color: '#ffffff',
                                },
                          ]),attrs:{"disabled":!_vm.selected_new.settingNoti_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.settingNoti_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('store')},model:{value:(_vm.selected_new.store_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "store_Checked", $$v)},expression:"selected_new.store_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.store_Checked == false ?
                      [!_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.store_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.store_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.store_Checked == false ?
                      [ !_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.store_Checked == true && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.store_Checked == false && _vm.selected_new.store_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.store_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.store_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('dashboard')},model:{value:(_vm.selected_new.dashboard_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "dashboard_Checked", $$v)},expression:"selected_new.dashboard_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.dashboard_Checked == false ?
                      [ !_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.dashboard_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.dashboard_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.dashboard_Checked == false ?
                      [ !_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.dashboard_Checked == true && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.dashboard_Checked == false && _vm.selected_new.dashboard_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.dashboard_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.dashboard_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("filter")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('trainingroadmapiso')},model:{value:(_vm.selected_new.skillMatrix_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "skillMatrix_Checked", $$v)},expression:"selected_new.skillMatrix_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.skillMatrix_Checked == false ?
                      [ !_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.skillMatrix_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.skillMatrix_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.skillMatrix_Checked == false ?
                      [ !_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.skillMatrix_Checked == true && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.skillMatrix_Checked == false && _vm.selected_new.skillMatrix_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.skillMatrix_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.skillMatrix_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add")+","+_vm.$t("edit")+","+_vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-6",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('live')},model:{value:(_vm.selected_new.live_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "live_Checked", $$v)},expression:"selected_new.live_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"70px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.live_Checked == false ?
                      [ !_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.live_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.live_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false ? [!_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]
                      
                      : _vm.selected_new.live_Checked == false ?
                      [ !_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]

                      : [_vm.selected_new.live_Checked == true && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 1 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ?  {'background-color': '#0000001f !important','color' : '#424242 !important'}
                      : _vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff','color' : '#A6CC39', 'border' : '1px solid #A6CC39'}
                      : !_vm.selected_new.live_Checked == false && _vm.selected_new.live_Permission == 0 ? {'background-color': '#ffffff !important','color' : '#424242 !important','border' : '1px solid #CCCCCC !important'}
                      : {'background-color': '#A6CC39', 'color' : '#ffffff'}]),attrs:{"disabled":!_vm.selected_new.live_Checked || _vm.editing},on:{"click":function($event){_vm.selected_new.live_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add")+","+_vm.$t("edit")+","+_vm.$t("delete")))])],1)],1)],1)],1),_c('v-divider',{staticClass:"mt-7 mb-6 mr-3",staticStyle:{"border":"1px solid #A6CC39"}}),_c('v-row',{staticClass:"mb-0"},[_c('v-col',{staticClass:"pl-3",attrs:{"cols":"12"}},[_c('span',{staticStyle:{"font-size":"20px","color":"#424242"}},[_vm._v(_vm._s(_vm.$t("reports")))])]),_c('v-col',{staticClass:"pt-0 pl-6",attrs:{"cols":"4"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('useractivityrp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.selected_new.userActivity_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "userActivity_Checked", $$v)},expression:"selected_new.userActivity_Checked"}})],1),_c('v-col',{staticClass:"pt-0 pl-6",attrs:{"cols":"4"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('usercourserp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.selected_new.userCourse_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "userCourse_Checked", $$v)},expression:"selected_new.userCourse_Checked"}})],1),_c('v-col',{staticClass:"pt-0",attrs:{"cols":"4"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('contentviewrp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.selected_new.userView_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "userView_Checked", $$v)},expression:"selected_new.userView_Checked"}})],1),_c('v-col',{staticClass:"pt-0 pl-6",attrs:{"cols":"4"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('requesteduserreport'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.selected_new.requestedUserRp_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "requestedUserRp_Checked", $$v)},expression:"selected_new.requestedUserRp_Checked"}})],1),_c('v-col',{staticClass:"pt-0 pl-6",attrs:{"cols":"4"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('ACReport'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.selected_new.acReport_Checked),callback:function ($$v) {_vm.$set(_vm.selected_new, "acReport_Checked", $$v)},expression:"selected_new.acReport_Checked"}})],1)],1)],1)],1),_c('v-card-actions',{staticClass:"mt-0 pt-2 pb-3",staticStyle:{"height":"70px","border-top":"1px solid #c0c0c05c"}},[_c('v-spacer'),_c('v-btn',{staticClass:"mr-3 text-capitalize",staticStyle:{"font-size":"18px","color":"#424242","border":"1px solid #c0c0c0","border-radius":"8px"},attrs:{"outlined":""},on:{"click":function($event){_vm.$emit('close'),
              _vm.$store.commit(
                _vm.editLevel ? 'openLevelEditDialog' : 'openLevelAddDialog'
              ),
              _vm.$store.commit(
                'saveSelectedLevelPermission',
                _vm.selectedLevelPermission
              )}}},[_vm._v(" "+_vm._s(_vm.$t("cancel"))+" ")]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"18px","color":"#ffffff","border-radius":"8px","box-shadow":"unset"},attrs:{"width":"110","color":"#A6CC39"},on:{"click":function($event){_vm.$emit('close'),
              _vm.$store.commit(
                _vm.editLevel ? 'openLevelEditDialog' : 'openLevelAddDialog'
              ),
              _vm.$emit('updatePermissions', _vm.selected_new),
              _vm.$store.commit('saveSelectedLevelPermission', _vm.selected_new)}}},[_vm._v(_vm._s(_vm.$t("update")))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }